export default "__VITE_ASSET__CppQUNZW__"